webpackJsonp([6],{

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(6);

$(function () {
    // 切换页面的拓客线索、智能触达等菜单
    var Element = document.createElement('div');
    var targetElement = 'home-data-logo';
    var activeElement = 'home-data-active';
    var switchElement = 'home-toke-clue';
    $('.home-data-logo > div:nth-child(1)').addClass(activeElement);
    $('.home-data-logo > div').mouseenter(function () {
        window.commonjs.switchToke($(this), //当前点击的div
        Element, //添加的倒三角图标
        targetElement, //切换的目标类名
        activeElement, //选中目标类名
        switchElement //切换的目标类名
        );
    });
});

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[5]);


// WEBPACK FOOTER //
// js/case.98a2fa.js